import { CUSTOM_FIELD_SUBJECT_TYPES, CUSTOM_FIELD_TYPES, CustomFieldParams } from "@/types/customFieldTypes";
import { CustomField } from "./customField";
import { ObjectInstance } from "../objectInstance";
import { isEmpty } from "@/backend/helpers/utils";

export class ObjectCustomField extends CustomField {
  objectInstance: ObjectInstance;

  constructor(data: CustomFieldParams) {
    super(data);
    this.objectInstance = data.objectInstance ? new ObjectInstance(data.objectInstance) : new NullObjectInstance();
  }

  getValue() {
    return this.objectInstance.properties.map(object => `${object.key}: ${object.file?.fileName || object.value}`).join(', ');
  }

  hasValidDefaultInput() { return true; }

  hasValidCustomInput() { return true; }

  isEmpty() {
    return this.objectInstance.properties.some(property => isEmpty(property.value));
  }

  getLabel() {
    return this.objectInstance.title;
  }
}

export class NullObjectInstance extends ObjectInstance {
  constructor() {
    super({
      id: '',
      createdAt: '',
      updatedAt: '',
      customFieldId: '',
      objectShapeId: '',
      properties: [],
      title: '',
    });
  }
}

export class NullObjectCustomField extends ObjectCustomField {
  constructor() {
    super({
      id: '',
      isRequired: false,
      createdAt: new Date(),
      updatedAt: new Date(),
      subjectId: '',
      subjectType: CUSTOM_FIELD_SUBJECT_TYPES.PARAMETER,
      fieldType: CUSTOM_FIELD_TYPES.Object,
      defaultValue: undefined,
      customValue: undefined,
      isSelected: false,
      objectInstance: new NullObjectInstance(),
    });
  }
}
